import { render, staticRenderFns } from "./Booths.vue?vue&type=template&id=41914e62&scoped=true&"
import script from "./Booths.vue?vue&type=script&lang=js&"
export * from "./Booths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41914e62",
  null
  
)

export default component.exports